/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Hero_LedeInputs */

const en_features_hero_lede = /** @type {(inputs: Features_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule, clients, plans, payments and group classes. On your laptop when you plan, and on your phone when you are on the gym floor.`)
};

const pl_features_hero_lede = /** @type {(inputs: Features_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik, podopieczni, plany, płatności i zajęcia grupowe. Na laptopie, kiedy planujesz, i w telefonie, kiedy stoisz na sali.`)
};

/**
* | output |
* | --- |
* | "Schedule, clients, plans, payments and group classes. On your laptop when you plan, and on your phone when you are on the gym floor." |
*
* @param {Features_Hero_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_hero_lede = /** @type {((inputs?: Features_Hero_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Hero_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_hero_lede(inputs)
	return en_features_hero_lede(inputs)
});